import { applyReady, giveup, applyCredit, getApplyInfo, saveApplyInfoStep1, getDict, saveApplyInfoStep2, getValidateUrl, applyHistory, getApplyProcess, getHistoryDetail } from '@/api/apply'
import { assignInWith, isNil } from 'lodash'
import { APPLY_STATUS } from './status'
const actions = {
  applyReady ({ state, commit }, payload) {
    let isIp = payload
    let lat = state.applyInfo.lat
    let lng = state.applyInfo.lng
    return applyReady(isIp).then(data => {
      if (isIp) {
        lat = data.lat
        lng = data.lng
      }
      commit('SET_APPLY', {
        lat: lat,
        lng: lng,
        userCookieId: data.userCookieId,
        caller: data.caller
      })
      return Promise.resolve()
    })
  },
  giveup ({ commit }) {
    giveup(state.applyInfo.applyId).then(() => {
      commit('SET_APPLY', {
        applyId: 0,
        applyStatus: 0
      })
      return Promise.resolve()
    })
  },
  applyCredit ({ commit }, payload) {
    return applyCredit(payload).then(data => {
      commit('UPDATE_USER_INFO', data)
      commit('SET_APPLY', {
        applyId: data.applyId,
        applyStatus: data.applyStatus
      })
      return Promise.resolve()
    })
  },
  getApplyInfo ({ commit }) {
    return getApplyInfo().then(data => {
      commit('SET_APPLY', data)
    })
  },
  saveApplyInfoStep1 ({ state, commit }, payload) {
    return saveApplyInfoStep1({
      applyId: state.applyInfo.applyId,
      ...payload
    }).then(data => {
      commit('SET_APPLY', data)
      return Promise.resolve()
    })
  },
  getDict ({ commit }) {
    getDict().then(data => {
      commit('SET_DICT', data)
    })
  },
  saveApplyInfoStep2 ({ state, commit }, payload) {
    return saveApplyInfoStep2({
      applyId: state.applyInfo.applyId,
      ...payload
    }).then(data => {
      commit('SET_APPLY', data)
    })
  },
  getValidateUrl ({ state, commit }, payload) {
    if (payload.tag === 'validMobile') {
      return getValidateUrl({
        applyId: state.applyInfo.applyId
      }).then(data => {
        commit('SET_VALIDATE_URL', data.redirect)
        return Promise.resolve()
      })
    } else {
      return Promise.resolve()
    }
  },
  next ({ state }, payload) {
    let component = payload.component
    switch(state.applyInfo.applyStatus) {
      case APPLY_STATUS.APPLY_BASIC_INFO:
        component.$router.push({
          name: 'apply/info',
          query: {
            applyId: state.applyInfo.applyId
          }
        })
        break
      case APPLY_STATUS.APPLY_PERSON_INFO:
        component.$router.push({
          name: 'apply/profile',
          query: {
            applyId: state.applyInfo.applyId
          }
        })
        break
      case APPLY_STATUS.APPLY_MOBILE_VALID:
      case APPLY_STATUS.APPLY_BANK_VALID:
      case APPLY_STATUS.APPLY_ZHIMA_VALID:
      case APPLY_STATUS.APPLY_BANK_VALID2:
        component.$router.push({
          name: 'apply/proving',
          query: {
            applyId: state.applyInfo.applyId
          }
        })
        break
      default:
        component.$router.push({
          name: 'index'
        })
        break
    }
  },
  getApplyProcess ({ state, commit }, payload) {
    let applyId = 0
    if (payload && Number(payload) > 0) {
      applyId = Number(payload)
    } else {
      applyId = state.applyInfo.applyId
    }
    if (applyId > 0) {
      return getApplyProcess({
        applyId: applyId
      }).then(data => {
        commit('SET_APPLY_RESULT', data)
        return Promise.resolve()
      })
    }
  },
  applyHistory ({ commit }) {
    applyHistory().then(data => {
      commit('SET_APPLY_HISTORY', data)
    })
  },
  getHistoryDetail ({ commit }, payload) {
    return getHistoryDetail({applyId: payload}).then(data => {
      commit('SET_HISTORY_DETAIL_INFO', data)
      return Promise.resolve(data) 
    })
  }
}

const mutations = {
  'SET_APPLY' (state, payload) {
    if (typeof payload == 'object') {
      state.applyInfo = assignInWith(state.applyInfo, {
        nContractor: payload.emContact,
        nMobile: payload.emMobile,
        nRelationship: payload.emRelationship,
        cardNumber: payload.creditCard
      }, payload, (objVal, srcVal) => {
        return isNil(srcVal) ? objVal : (srcVal === -1 ? '' : srcVal)
      })
    } else {
      state.applyInfo.applyId = payload || 0
    }

    if ([APPLY_STATUS.APPLY_BANK_VALID, APPLY_STATUS.APPLY_BANK_VALID2].indexOf(state.applyInfo.applyStatus) > -1) {
      state.validMobile = -1
      state.validBank = 1
    }
    if (APPLY_STATUS.APPLY_MOBILE_VALID === state.applyInfo.applyStatus) {
      state.validMobile = 1
    }
  },
  'SET_PROVING' (state, payload) {
    state.validBank = payload.validBank || 0
    state.validMobile = payload.validMobile || 0
  },
  'SET_DICT' (state, payload) {
    state.dict = payload
  },
  'SET_VALIDATE_URL' (state, payload) {
    state.redirectURL = payload
  },
  'SET_APPLY_HISTORY' (state, payload) {
    state.applyHistory = payload.list
    state.historyCount = payload.count
  },
  'SET_APPLY_RESULT' (state, payload) {
    if (payload.applyStepInfo.length > 0) {
      state.result = {
        title: payload.applyStepInfo[1].title,
        desc: payload.applyStepInfo[1].desc,
        success: payload.success,
        finished: payload.finished,
        irr36: payload.irr36,
        isdaoliu: payload.isdaoliu,
      }
    } else {
      state.result = {
        title: '您的申请资料已提交审核',
        desc: '申请已提交',
        success: payload.success,
        finished: payload.finished
      }
    }
  },
  'RESET_APPLY' (state) {
    state.applyInfo = {
      applyId: 0,
      applyStatus: 0,
      lat: 0,
      lng: 0,
      userCookieId: Date.now(),
      caller: 3,
      creditCard: '',
      nContractor: '',
      nMobile: '',
      nRelationship: '',
      cardNumber: '',
      homeSituation: '',
      workExperience: '',
      income: ''
    }
    state.result = {
      title: '',
      desc: '',
      success: false,
      finished: false
    }
    state.applyHistory = []
    state.validBank = 0
    state.validMobile = 0
    state.redirectURL = ''
    state.dict = {}
  },
  'SET_HISTORY_DETAIL_INFO' (state, payload) {
    state.historyDetail = payload
  }
}

const state = {
  applyInfo: {
    applyId: 0,
    applyStatus: 0,
    lat: 0,
    lng: 0,
    userCookieId: Date.now(),
    caller: 3,
    creditCard: '',
    nContractor: '',
    nMobile: '',
    nRelationship: '',
    cardNumber: '',
    homeSituation: '',
    workExperience: '',
    income: ''
  },
  result: {
    title: '',
    desc: '',
    success: false,
    finished: false
  },
  historyDetail: {},
  applyHistory: [],
  validMobile: 0,
  validBank: 0,
  redirectURL: '',
  dict: {}
}

export default {
  state,
  mutations,
  actions
}
